import { Control, FormState } from 'react-hook-form';
import { Fragment } from 'react/jsx-runtime';
import { useRef } from 'react';
import { FormConfig } from './formBuilder.types';
import { FormBuilderItem } from './FormBuilderItem';
import {
  FormBuilderLabel,
  FormBuilderGroup as Group,
} from './FormBuilderLayout';
import { useWidth } from '../../utilities/useWidth.hook';

type FormBuilderProps<T> = {
  config: FormConfig<T>;
  control: Control<T>;
  formState?: FormState<T>;
  disabled?: boolean;
};

export const FormBuilder = <T,>({
  config,
  control,
  formState,
  disabled,
}: FormBuilderProps<T>) => {
  const containerRef = useRef(null);
  const width = useWidth(containerRef);

  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      {config.map((item, index) => {
        if (!item) {
          return <Fragment key={index} />;
        }
        const isArray = Array.isArray(item);

        if (!isArray && item.type === 'label') {
          return <FormBuilderLabel key={index}>{item.label}</FormBuilderLabel>;
        }
        const Component = isArray || item.type === 'group' ? Fragment : Group;
        return (
          <Component key={index}>
            <FormBuilderItem
              formItem={item}
              control={control}
              formState={formState}
              formWidth={width}
              disabled={disabled}
            />
          </Component>
        );
      })}
    </div>
  );
};
